module.exports = __webpack_public_path__ + "img/padding.1f6fc14d.png";